module.exports = __webpack_public_path__ + "assets/img/0569-za.svg";